import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  pagingAsyncAppointment,
} from "app/services/AppointmentService";
import { syncListAppointmentToCrm } from "app/services/SyncCRMService";

export default class AppointmentAsyncStore {
  searchAppointment = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
  };
  pageAppointment = new PageResponse();
  selectAppointmentAsync = [];
  resetSelectedRows = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingAppointment = async () => {
    let { departmentId, telesaleId, ...ortherData } = this.searchAppointment;
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    } else {
      ortherData.departmentId = null;
    }
    if (telesaleId) {
      ortherData.telesaleId = telesaleId?.id;
    } else {
      ortherData.telesaleId = null;
    }
    return await pagingAsyncAppointment({ ...ortherData })
      .then(({ data }) => {
        this.pageAppointment = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch hẹn khách hàng có lỗi");
      });
  };

  handleChangeFormSearch = (searchAppointment) => {
    this.searchAppointment = {
      ...this.searchAppointment,
      ...searchAppointment,
    };
    this.pagingAppointment();
  };

  setSelectAppointmentAsync = (list) => {
    this.selectAppointmentAsync = list;
  };

  syncListPatientToCrm = async () => {
    const appointmentIds = this.selectAppointmentAsync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;

    return await syncListAppointmentToCrm({ appointmentIds })
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        if (data) {
          toast.success("Đồng bộ lịch hẹn thành công");
          this.pagingAppointment();
        } else {
          toast.error("Đồng bộ lịch hẹn có lỗi");
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        console.error(error);
        toast.error("Đồng bộ lịch hẹn có lỗi");
      });
  };
  resetStore = () => {
    this.searchAppointment = {
      ...new SearchObject(),
      isSyncedToCRM: false,
      fromLastDateSync: new Date(
        new Date().setMonth(new Date().getMonth() - 1)
      ),
      toLastDateSync: new Date(),
      departmentId: null,
    };
    this.pageAppointment = new PageResponse();
  };
}
